// extracted by mini-css-extract-plugin
export var appStores = "W_dp";
export var grey = "W_dq";
export var icon = "W_bz";
export var iconGroup = "W_dn";
export var image = "W_d";
export var left = "W_bG";
export var reverse = "W_dm";
export var right = "W_bH";
export var section = "W_b";
export var textSection = "W_dl";